export default __webpack_public_path__ + "assets/enterprise-one-three.9db10714ec725d2894efc256fd7bf28b.png";